import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { WORKSPACE_VERSION } from '@/api/workspace';

interface GetSharedTabListResponse {
  owner: string;
  itemKey: string;
}

export function getSharedTabListQuery(builder: WebapiEndpointBuilder) {
  return builder.query<GetSharedTabListResponse[], void>({
    query: () => ({
      url: `/userdata/workspace/shared/all/${WORKSPACE_VERSION}`,
      method: 'GET',
    }),
  });
}
